import { FactoryProvider, Optional, SkipSelf } from '@angular/core';

import { NaScreenfullService } from './na-screenfull.service';

export function SCREEN_SERVICE_FACTORY(
  parent: NaScreenfullService
): NaScreenfullService {
  return parent || new NaScreenfullService();
}

export const SCREEN_SERVICE_PROVIDER: FactoryProvider = {
  provide: NaScreenfullService,
  deps: [[new Optional(), new SkipSelf(), NaScreenfullService]],
  useFactory: SCREEN_SERVICE_FACTORY
};
